export default {
  checkboxItemAlign: 'center',
  checkBoxMArginTop: '1.2rem',
  unmarkedBorder: '2px solid var(--sg-grey-500)',
  checkedColor: 'var(--digi-blue-400)',
};
